import { DocumentSupportDetailModel } from 'src/app/models/shopping/document-support-detail.model';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DocumentSupportModel } from 'src/app/models/shopping/document-support.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentSupportDetailService {

  private readonly _httpClient = inject(HttpClient);

  getAllDocumentsSupportDetailsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetAllDocumentSupportDetailWithPagination}`,
      filters, { params: params }
    );
  }

  getArticlesForDocumentSupport(documentSupportId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('documentSupportId', documentSupportId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetArticlesForDocumentSupport}`,
      filters, { params: params }
    );
  }

  getColumnsForArticleCaptureDocumentSupport(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetColumnsForArticleCaptureDocumentSupport}`);
  }

  getColumnsForDetailCapture(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetColumnsForDetailCapture}`);
  }


  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetColumnsForDetailConsultation}`);
  }

  createDocumentSupport(documentSupportDetailContract: DocumentSupportDetailModel): Observable<DocumentSupportDetailModel> {
    return this._httpClient.post<DocumentSupportDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.CreateDocumentSupportDetail}`,
      documentSupportDetailContract);
  }

  createDetailsDocumentSupport(documentSupportDetails: DocumentSupportDetailModel[], documentSupportDetailId: number): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.CreateDetails}/${documentSupportDetailId}`,
      documentSupportDetails);
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.ExportDetailConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  updateDocumentSupportDetail(documentSupportDetail: DocumentSupportDetailModel): Observable<DocumentSupportDetailModel> {
    return this._httpClient.put<DocumentSupportDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.UpdateDocumentSupportDetail}`, documentSupportDetail);
  }

  deleteSomeDocumentSupportDetails(documentSupportDetailIds: Array<number>): Observable<DocumentSupportModel> {
    return this._httpClient.put<DocumentSupportModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.DeleteSomeDetails}`,
      documentSupportDetailIds);
  }

  getDocumentSupportDetailByDocumentSupportId(id: number): Observable<DocumentSupportDetailModel> {
    return this._httpClient.get<DocumentSupportDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetDocumentSupportDetailById}/${id}`);
  }

  getDocumentSupportDetailsByDocumentSupport(page: number, limit: number, columnSort: string | null, ascendant: boolean, documentSupportId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant).set('documentSupportId', documentSupportId);
    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetDocumentSupportDetailsByDocumentSupport}`,
      { params }
    );
  }

  getDocumentSupportDetailByKeys(documentSupportId: number, articleId: number): Observable<DocumentSupportDetailModel> {
    const params = new HttpParams().set('documentSupportId', documentSupportId).set('articleId', articleId);
    return this._httpClient.get<DocumentSupportDetailModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.documentSupportDetail.GetDocumentSupportDetailByKeys}`,
      { params: params }
    );
  }
}
